import { render, staticRenderFns } from "./accountspayable-detail.vue?vue&type=template&id=27c2f0b8"
import script from "./accountspayable-detail.vue?vue&type=script&lang=js"
export * from "./accountspayable-detail.vue?vue&type=script&lang=js"
import style0 from "./accountspayable-detail.vue?vue&type=style&index=0&id=27c2f0b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports